module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img45.3a4730bb.jpg";